import { ReactNode } from 'react';
import FusePageSimple from '@fuse/core/FusePageSimple';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import RefreshIcon from '@mui/icons-material/Refresh';

const Root = styled(FusePageSimple)(({ theme }) => ({
	'& .FusePageSimple-header': {
		backgroundColor: theme.vars.palette.background.paper,
		borderBottomWidth: 1,
		borderStyle: 'solid',
		borderColor: theme.vars.palette.divider
	}
}));

interface HealthPageShellProps {
	title: string;
	subtitle?: string;
	onRefresh?: () => void;
	refreshDisabled?: boolean;
	children: ReactNode;
}

export function HealthPageShell({
	title,
	subtitle,
	onRefresh,
	refreshDisabled,
	children
}: HealthPageShellProps) {
	return (
		<Root
			header={
				<div className="p-6 flex items-center justify-between gap-4">
					<div>
						<Typography className="text-2xl font-bold">{title}</Typography>
						{subtitle && (
							<Typography color="text.secondary" className="text-sm">
								{subtitle}
							</Typography>
						)}
					</div>
					{onRefresh && (
						<Tooltip title="Refresh">
							<IconButton onClick={onRefresh} disabled={refreshDisabled}>
								<RefreshIcon />
							</IconButton>
						</Tooltip>
					)}
				</div>
			}
			content={<div className="p-6 flex flex-col gap-6">{children}</div>}
		/>
	);
}

export function formatRelative(iso: string): string {
	const then = new Date(iso).getTime();
	const diff = Date.now() - then;
	const mins = Math.floor(diff / 60_000);
	if (mins < 1) return 'just now';
	if (mins < 60) return `${mins}m ago`;
	const hours = Math.floor(mins / 60);
	if (hours < 24) return `${hours}h ago`;
	const days = Math.floor(hours / 24);
	return `${days}d ago`;
}
